var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apple-pay-button',_vm._g({attrs:{"buttonstyle":"black","type":"donate","locale":_vm.locale}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }